const url = {
  login: "/auth/login",
  exam: {
    getAllExams: "exam/getAllExam",
    crateExam: "exam/createExam",
    deleteOneExam: "exam/deleteOneExam",
    updateExam: "/exam/updateExam",
    getExamById: "/exam/getExamById",
    getExamStatus: "/exam/getExamStatuses",
    updateExamStatus: "/exam/updateExamStatus",
    uploadCandidateData: "/examMapping/uploadUserCsvData",
    uploadZipUserData: "/examMapping/uploadZipUserData",
    getAllMappedUser: "/examMapping/getAllMappedUser",
    deleteMappingForExam: "/examMapping/deleteExamMappingForExam",
    getExamLanguage: "/exam/getExamLanguages",
    setExamDateAndTime: "/exam/updateExamTime",
    setuserAllowedTillTime: "/exam/updateUserTillTime",
    setUserAllowedTime: "/exam/updateUserAllowedExamTime",
    getUserAllowedExamTime: "/exam/getUserAllowedExamTime",
    markExamCompleted: "/exam/markAsCompleted",
    getAllUsers: "/exam/getAllExamStudents",
    getExamLayout: "/exam/getExamLayout",
    getQuestionData: "/admin/getQuestionData",
  },
  admin: {
    getQuestionsByExamId: "admin/getQuestionsByExamId",
    getQuestionById: "admin/getQuestionById",
    addQuestionToExam: "admin/addQuestionToExam",
    addAnswerToQuestion: "admin/addAnswerToQuestion",
    addQuestionToQuestionById: "admin/addQuestionToQuestion",
    makeExamive: "/admin/makeExamLive",
    getExamsections: "/admin/getExamSections",
    addOptionToQuestion: "/admin/addOptionToQuestion",
    deleteQuestionFromQuestionId: "/admin/deleteQuestionFromQuestionById",
    userAllowedStartTime: "/exam/userAllowedStartTime",
    getQuestionDataByExamIdAndSectionId:
      "/exam/getExamQuestionsByExamIdSectionId",
    deleteQuestionById: "/admin/deleteQuestionById",
    deleteOptionById: "/admin/deleteOptionById",
    deleteQuestionFromQuestion: "/admin/deleteQuestionFromQuestionById",
    getAllResponsesByExamId: "/admin/getAllResponsesByExamId",
    deleteStatementById: "/admin/deleteStatementById",
    getUserResponseByMappingId: "/admin/getUserResponseByMappingId",
    getAllCompletedUsersForExam: "/admin/getAllCompletedUsersForExam",
    getS3Link: "/admin/getS3Link",
    getDecriptionKeys: "/admin/getDecriptionKeys",
    setTimeMapping: "/admin/addChangeMappingTime",
    toggleUserActive: "/admin/toggleUserActive",
    resetMappingTime: "/admin/resetMappingTime",
    deleteQuestionDicomByQuestionDataId:
      "/admin/deleteQuestionDicomByQuestionDataId",
    deleteQuestionImageByQuestionDataId:
      "/admin/deleteQuestionImageByQuestionDataId",
    deleteQuestionDataAsImage: "/admin/deleteQuestionAsImage",
    duplicateQuestion: "/admin/duplicateQuestion",
    questionMoveQuestionId: "/admin/question/move",
    user_logs: "/admin/user/logs",
  },
  user: {
    getAllUsers: "/admin/getAllUser",
    resetPasswordForUser: "/user/resetPasswordForUser",
    deleteStudentMapping: "/examMapping/deleteStudentMapping",
    disableStudentMapping: "/examMapping/disableStudentMapping",
    toggleStudentMapping: "/examMapping/toggleStudentMapping",
    unMarkCompletedMapping: "/examMapping/unMarkCompletedMapping",
  },
  logs: {
    getAllLogs: "/log/getAllLogs",
    getAllLogsByMappingId: "/log/getAllLogsByMappingId",
  },
  pulic: {
    getQuestionType: "/public/getQuestionTypes",
    getOptionType: "/public/getOptionTypes",
    getQuestionDataTypes: "/public/getQuestionDataTypes",
    getAllLanguages: "/public/getAllLanguages",
  },
  result: {
    getResultResponse: "/result/getResponses",
    getEncryptedOptionById: "/result/getencryptedOptionsById",
    createUserResultCSVByExamId: "/result/createUserResultCSVByExamId",
    ans_mark: "/answer/result/mark",
    getQuestionAnswersByExamId: "/answer/result/getQuestionAnswers",
    generateResult: "/answer/result/create",
    createUserResult: "/result/createUserResult",
    downloadExistingResultZip: "/result/downloadExistingResultZip",
  },

  client: {
    createClient: "/client/create",
    getAllClient: "/client/get",
    updateClientPassword: "/client/update/password",
    deleteClient: "/client/delete",
  },

  centerAdmin: {
    create: "/admin/center-admin/create",
    update: "/admin/center-admin/update",
    getAll: "/admin/center-admin/get",
    toggleSuspend: "/admin/center-admin/toggle-disable",
    resetPassword: "/admin/center-admin/reset-password",
  },

  invigilator: {
    getAllByExam: (examId: string) => `/admin/invigilator/all/${examId}`,
    getDetails: (invigilatorId: string) =>
      `/admin/invigilator/${invigilatorId}`,
    create: "/admin/invigilator/create",
    update: (invigilatorId: string) => `/admin/invigilator/${invigilatorId}`,
    updateStatus: (invigilatorId: string) =>
      `/admin/invigilator/status/${invigilatorId}`,
    resetPassword: (invigilatorId: string) =>
      `/admin/invigilator/password/${invigilatorId}`,
    delete: (invigilatorId: string) => `/admin/invigilator/${invigilatorId}`,
    assignStudents: (invigilatorId: string) =>
      `/admin/invigilator/assign/${invigilatorId}`,
    getAssignedStudents: (invigilatorId: string) =>
      `/admin/invigilator/${invigilatorId}`,
  },

  company: {
    getCompany: (pageNumber = 1, limit = 10, search = "") =>
      `/admin/company?page=${pageNumber}&limit=${limit}&search=${search}`,
    createCompany: "/admin/company",
    getDetails: (companyId: string) => `/admin/company/${companyId}`,
    updateCompany: (id: string) => `/admin/company/${id}`,
    updateStatus: (companyId: string) => `/admin/company/status/${companyId}`,
    delete: (companyId: string) => `/admin/company/${companyId}`,
    aiFeatures: "/admin/company/ai-features",
    resetPassword: (companyId: string) =>
      `/admin/company/reset-password/${companyId}`,
    makeBucketPublic: (companyId: string) =>
      `/admin/company/bucket/public/${companyId}`,
    makeBucketPrivate: (companyId: string) =>
      `/admin/company/bucket/private/${companyId}`,
    getSubscription:'/admin/company/subscription',
    subscribeSubscription:'/admin/company/subscription/subscribe',
    updateSubscription:'/admin/subscriptions',
    getSubscriptionById: (subId: string) => `/admin/subscriptions/${subId}`,
  },

  plan: {
    getAllPlan: (pageNumber = 1, limit = 10, search = "") =>
      `/admin/plans?page=${pageNumber}&limit=${limit}&search=${search}`,
    createPlan: `/admin/plans`,
    getPlanDetails: (id: string) => `/admin/plans/${id}`,
    updatePlan: (id: string) => `/admin/plans/${id}`,
    updateStatus: (id: string) => `/admin/plans/status/${id}`,
    
    plansForDropdown: '/admin/plans/dropdown'
  },

  subscription: {
      getAll: (page = 1, limit = 10) =>
    `/admin/subscriptions?page=${page}&limit=${limit}`,

    getById: (id: string) => `/admin/subscriptions/${id}`,

    update: (id: string) => `/admin/subscriptions/${id}`,

    updateStatus: (id: string) => `/admin/subscriptions/status/${id}`,
    
  },

  users: {
    getAll: (pageNumber = 1, pageSize = 50, search) =>
      `/admin/user/all?pageNumber=${pageNumber}&pageSize=${pageSize}&search=${search}`,
  },

  getAllExamCities: "/examMapping/cities",
};

export default url;
